module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['block', _vm.color],
    attrs: {
      "title": _vm.title
    },
    on: {
      "click": _vm.routeClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-954b0986!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/Block.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-954b0986!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/Block.vue
// module chunks = 0